import { RSAA } from 'redux-api-middleware';
import A from 'actions/passwordResetActions';
import validator from 'validator';

export const 
updateResetField = (field, value) => ({ type: A.HOME_UPDATE_RESET_FIELD, payload: { field, value }}),
updateFieldFormProps = (field, props) => ({ type: A.HOME_UPDATE_RESET_FIELD, payload: { field, props }}),
clearResetField = field => ({ type: A.HOME_CLEAR_RESET_FIELD, payload: field }),
clearRequestPasswordReset = () => ({ type: A.HOME_CLEAR_REQUEST_PASSWORD_RESET }),
togglePasswordResetModal = () => ({ type: A.HOME_TOGGLE_PASSWORD_RESET_MODAL }),
resetEmailUpdateRequest = () => ({ type: A.HOME_RESET_UPDATE_EMAIL_UPDATE_REQUEST }),
resetPasswordResetRequest = () => ({ type: A.HOME_RESET_UPDATE_NEW_PASSWORD_REQUEST }),
resetExpiredPasswordRequest = () => ({ type: A.HOME_RESET_UPDATE_EXPIRED_PASSWORD_REQUEST }),

requestPasswordReset = (emailId, captcha, password ) => ({ [RSAA]: {
    method: 'POST',
    endpoint: '/user/reset',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        id: emailId,
        type: validator.isEmail(emailId) ? 'EMAIL' : 'USERNAME',
        password: password || null,
        captcha: captcha || null
    }),
    types: [
        A.HOME_PENDING_PASSWORD_RESET_REQUEST,
        A.HOME_SUCCESS_PASSWORD_RESET_REQUEST,
        A.HOME_FAILURE_PASSWORD_RESET_REQUEST
    ]
}}),

updateNewPassword = (token, newPassword) => ({ [RSAA]: {
    endpoint: '/user/reset',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        password: newPassword,
        token: token
    }),
    types: [
        A.HOME_PENDING_UPDATE_NEW_PASSWORD,
        A.HOME_SUCCESS_UPDATE_NEW_PASSWORD,
        A.HOME_FAILURE_UPDATE_NEW_PASSWORD
    ]
}}),

updateExpiredPassword = (userName, oldPassword, newPassword) => ({ [RSAA]: {
    endpoint: '/user/reset-password',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        oldPassword: oldPassword,
        password: newPassword,
        id: userName
    }),
    types: [
        A.HOME_PENDING_UPDATE_EXPIRED_PASSWORD,
        A.HOME_SUCCESS_UPDATE_EXPIRED_PASSWORD,
        A.HOME_FAILURE_UPDATE_EXPIRED_PASSWORD
    ]
}}),

resetEmail = (userName, newEmail, passportNumber, passportCountry, answer1, answer2, answer3) => ({ [RSAA]: {
    endpoint: '/user/reset-email',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        userName,
        newEmail,
        passportNumber,
        passportCountry,
        answer1,
        answer2,
        answer3
    }),
    types: [
        A.HOME_PENDING_UPDATE_NEW_EMAIL,
        A.HOME_SUCCESS_UPDATE_NEW_EMAIL,
        A.HOME_FAILURE_UPDATE_NEW_EMAIL
    ]
}});

export const checkExpiredToken = (token) => ({ [RSAA]: {
    endpoint: '/user/reset-expiredtoken',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        token: token
    }),
    types: [
        A.CHECK_EXPIRED_REQUEST,
        A.CHECK_EXPIRED_SUCCESS,
        A.CHECK_EXPIRED_FAILURE
    ]
}});